import React, { Component } from 'react';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import withStyles from '@mui/styles/withStyles';
import Label from './Label';
import { getElementValueWrapper, onChangeWrapper } from '../../utils/objects';
import { getValidationDecorations } from '../../utils/validation';
import { joinDefined } from '../../utils/strings';

class FormRadioGroup extends Component {
    state = {};

    render() {
        const {
            className,
            name,
            row,
            form,
            value,
            options,
            label,
            onChange,
            onChanging,
            labelProps,
            groupProps,
            radioProps,
            labelField,
            valueField,
            disabled,
            validationResult,
            helperText,
            ...other
        } = this.props;

        const id = `radio-${name}`;
        const { className: labelClassName, ...otherLabelProps } = labelProps;
        const { className: groupClassName, ...otherGroupProps } = groupProps;
        const currentValue = !!getElementValueWrapper(this) ? getElementValueWrapper(this) : '';
        const decorations = getValidationDecorations(this.props);

        return (
            <FormControl
                className={`radio-group ${joinDefined(
                    [className, decorations.cssClass, disabled ? 'disabled' : null],
                    ' '
                )}`}
                role="group"
                aria-labelledby={id}
                disabled={disabled}
                {...other}
            >
                {label && <Label id={id} text={label} {...otherLabelProps} />}
                <div className="control">
                    <RadioGroup
                        className={groupClassName}
                        aria-label={label}
                        name={name}
                        value={currentValue}
                        onChange={e => onChangeWrapper(e, this)}
                        row={row}
                        {...otherGroupProps}
                    >
                        {options.map(o => {
                            const lbl = labelField ? o[labelField] : o.value;
                            const val = valueField ? o[valueField] : o.value;
                            return (
                                <FormControlLabel
                                    key={val}
                                    value={val}
                                    label={lbl}
                                    classes={{ label: 'form-label' }}
                                    control={
                                        <Radio
                                            className={currentValue === val ? 'checked' : ''}
                                            color="primary"
                                            {...radioProps}
                                        />
                                    }
                                    {...o}
                                />
                            );
                        })}
                    </RadioGroup>
                    {(decorations.errorMsg || !!helperText) && (
                        <FormHelperText
                            error={decorations.inError === true}
                            classes={{
                                error: `validation-label ${decorations.cssClass}`
                            }}
                        >
                            {decorations.errorMsg || helperText}
                        </FormHelperText>
                    )}
                </div>
            </FormControl>
        );
    }
}

FormRadioGroup.defaultProps = {
    row: true,
    fullWidth: false,
    labelProps: {},
    groupProps: {},
    radioProps: {}
};

export default withStyles({})(FormRadioGroup);
